<template>
  <div style="padding: 1em 2em 2em; border-top: 1px solid #ddd;">
    <div v-if="showForm">
      <form ref="uploadForm">

        <div class="clearfix" v-if="usecase === 'auction'">
          <fieldset class="col24">
            <label for="description">Description</label>
            <input type="text" v-model="description" id="description" maxlength="255" required="required" />
          </fieldset>
          <fieldset class="col14">
            <label for="file">File</label>
            <input type="file" id="file" ref="file" required="required" />
          </fieldset>
          <fieldset class="col14">
            <label for="visibility">Visibility</label>
            <select v-model="visibility" id="visibility" required="required">
              <option :value="fileVisibility.PUBLIC.value">{{ fileVisibility.PUBLIC.label }}</option>
              <option :value="fileVisibility.LOGGED_IN.value">{{ fileVisibility.LOGGED_IN.label }}</option>
              <option :value="fileVisibility.AUTHORIZED.value">{{ fileVisibility.AUTHORIZED.label }}</option>
            </select>
          </fieldset>
        </div>

        <div class="clearfix" v-else-if="usecase === 'buyerdocs'">
          <fieldset class="col13">
            <label for="description">Description</label>
            <input type="text" v-model="description" id="description" maxlength="255" required="required" />
          </fieldset>
          <fieldset class="col13">
            <label for="file">File</label>
            <input type="file" id="file" ref="file" required="required" />
          </fieldset>
          <fieldset class="col13">
            <label for="fileDocType">File Document Type</label>
            <select id="fileDocType" v-model="fileDocType" required>
              <option v-for="doc in buyerRequirementOptions" :key="doc.id" :value="doc.id">{{ doc.text }}</option>
            </select>
          </fieldset>
        </div>

        <button @click.prevent="showForm = false">Cancel</button>
        <button @click.prevent="doUpload">Upload</button>
      </form>
    </div>
    <div v-else style="text-align: center">
      <v-icon>file_upload</v-icon> <a @click.prevent="showForm = true">Upload a new file</a>
    </div>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import { fileVisibility } from '../../utils/PfxUtils.js'

  export default {
    name: 'FileUpload',
    props: {
      auctionId: {
        type: Number,
        required: true
      },
      uploadCallback: {
        type: Function,
        required: true
      },
      usecase: {
        type: String,
        required: true,
        validator: (value) => { return [ 'auction', 'buyerdocs' ].indexOf(value) !== -1 }
      }
    },
    data() {
      return {
        fileVisibility,
        showForm: false,
        description: '',
        visibility: this.usecase === 'buyerdocs' ? 'PRIVATE' : 'AUTHORIZED',
        buyerRequirementOptions: []
      }
    },
    created() {
      this.$PfxBackendApi.getBuyerRequirementsOptions().then(res => {
          // console.log('getBuyerRequirementsOptions res', res)
          res.data.forEach(document => {
            let item = { text: document.name, id: document.id }
            this.buyerRequirementOptions.push(item)
          })
          console.log('getBuyerRequirementsOptions Array: ', this.buyerRequirementOptions)
        }).catch(err => {
          console.error('getBuyerRequirementsOptions err', err)
        })
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner'
      ]),

      checkDocType(){
        if(this.fileDocType == null)
          return 99
        else
          return this.fileDocType
      },
      doUpload() {
        if (!this.$refs.uploadForm.checkValidity()) {
          this.$refs.uploadForm.reportValidity()
          return
        }

        const file = this.$refs.file.files[0]
        if (!file) {
          console.log('no file, abort')
          return
        }

        let fileData = {
          name: file.name,
          type: file.type,
          size: file.size,
          desc: this.description,
          dueDiligence: this.dueDiligence,
          visibility: this.visibility,
          docType: this.checkDocType()
        }

        const that = this
        const reader = new FileReader()
        reader.onloadstart = () => {
          this.setLoadingSpinner(true)
        }
        reader.onerror = (err) => {
          console.error('reader.onerror', err)
          this.$notify({ type: 'danger', message: 'Error during file upload. Plese retry.' })
          this.setLoadingSpinner(false)
        }
        reader.onload = () => {
          fileData.data = reader.result
          this.$PfxBackendApi.fileUpload(this.auctionId, fileData).then(res => {
            console.log('fileUpload res', res)
            this.uploadCallback(res.data)
            if (that.$refs.uploadForm) {
              that.$refs.uploadForm.reset()
            }
          }).catch(err => {
            console.error('fileUpload err', err)
            this.$notify({ type: 'danger', message: 'Cannot upload the file' })
          }).then(() => {
            this.setLoadingSpinner(false)
          })
        }
        reader.readAsDataURL(file)
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col13 { @include column(1/3); }
  .col23 { @include column(2/3); }
  .col14 { @include column(1/4); }
  .col24 { @include column(2/4); }
</style>



// WEBPACK FOOTER //
// src/components/elements/FileUpload.vue